import React from "react";
import FormItem from "../../../components/FormItem";
import t from '../../../helpers/t';
import {$} from "../../../../../vendor";

const BoxesSelect = (props) => {
    const {boxes, selectedBox, setSelectedBox} = props;
    const onChange = (e) => {
        $('.inb-c-item--select-box select').css('border-color','rgb(227, 227, 227)');
        setSelectedBox(e.target.value);
    }
    return (
        <>
            <FormItem
                type="select"
                labelStyle={{}}
                label={t('free boxes')}
                placeholder={t('please_select')}
                data={boxes}
                dataKey="id"
                nameSub='resource'
                nameAttribute='name'
                onChangeHandler={onChange}
                selected={selectedBox}
            />
        </>
    )
}
export default BoxesSelect;